// ── MOBILE NAV ───────────────────────────────────────────
function toggleMenu(){
  document.getElementById('hamburger').classList.toggle('open');
  document.getElementById('mobNav').classList.toggle('open');
  document.body.style.overflow = document.getElementById('mobNav').classList.contains('open') ? 'hidden' : '';
}
function closeMenu(){
  document.getElementById('hamburger').classList.remove('open');
  document.getElementById('mobNav').classList.remove('open');
  document.body.style.overflow = '';
}

// ── CAROUSEL ─────────────────────────────────────────────
let carPos = 0;
function slide(dir){
  const track = document.getElementById('carTrack');
  if(!track) return;
  const items = track.querySelectorAll('.carousel-item');
  const w = window.innerWidth;
  const visible = w > 900 ? 4 : w > 600 ? 2 : 1;
  carPos = Math.max(0, Math.min(carPos + dir, items.length - visible));
  track.style.transform = 'translateX(-' + (carPos * (items[0].offsetWidth + 10)) + 'px)';
}

// ── TOAST ────────────────────────────────────────────────
function showToast(msg){
  const t = document.getElementById('toast');
  if(!t) return;
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(function(){ t.classList.remove('show'); }, 2800);
}

// ── MODAL ────────────────────────────────────────────────
function openModal(el){
  const card = el.closest('[data-product]');
  if(!card) return;
  const d = card.dataset;

  document.getElementById('modal-name').textContent = d.title || '';
  document.getElementById('modal-origin').textContent = d.origin || '';
  document.getElementById('modal-desc').textContent = d.desc || '';

  // Specs
  const specs = document.getElementById('modal-specs');
  specs.innerHTML = '';
  var specData = [
    ['Process', d.process],
    ['Varietal', d.varietal],
    ['Altitude', d.altitude],
    ['Roast', d.roast]
  ];
  specData.forEach(function(item){
    if(!item[1] || item[1] === 'undefined') return;
    specs.innerHTML += '<div class="spec"><p class="spec-label">' + item[0] + '</p><p class="spec-val">' + item[1] + '</p></div>';
  });

  // Notes
  const notes = document.getElementById('modal-notes');
  notes.innerHTML = '';
  if(d.notes){
    d.notes.split(',').forEach(function(n){
      if(n.trim()) notes.innerHTML += '<span class="modal-note">' + n.trim() + '</span>';
    });
  }

  // Image
  const img = document.getElementById('modal-img');
  const ph = document.getElementById('modal-img-ph');
  if(d.image && d.image !== '' && d.image !== 'undefined'){
    img.src = d.image;
    img.style.objectPosition = d.focus || '50% 50%';
    img.style.display = 'block';
    if(ph) ph.style.display = 'none';
  } else {
    img.style.display = 'none';
    if(ph) ph.style.display = 'flex';
  }

  // Sizes / variants
  const sizesEl = document.getElementById('modal-sizes');
  sizesEl.innerHTML = '';
  if(d.variants && d.variants !== 'undefined'){
    const ids = d.variants.split(',');
    const prices = (d.prices || '').split(',');
    const titles = (d.variantTitles || '').split(',');
    ids.forEach(function(id, i){
      const btn = document.createElement('button');
      btn.className = 'size-btn' + (i === 0 ? ' active' : '');
      btn.dataset.variantId = id.trim();
      const priceFormatted = prices[i] ? formatMoney(parseInt(prices[i])) : '';
      btn.innerHTML = (titles[i] || id) + (priceFormatted ? '<small>' + priceFormatted + '</small>' : '');
      btn.addEventListener('click', function(){
        sizesEl.querySelectorAll('.size-btn').forEach(function(b){ b.classList.remove('active'); });
        this.classList.add('active');
      });
      sizesEl.appendChild(btn);
    });
  }

  document.getElementById('overlay').classList.add('open');
  document.getElementById('modal').classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeModal(){
  document.getElementById('overlay').classList.remove('open');
  document.getElementById('modal').classList.remove('open');
  document.body.style.overflow = '';
}

// ── DIRECT ADD TO CART (card button) ─────────────────────
function addToCartDirect(btn){
  var variantId = parseInt(btn.dataset.productId);
  if(!variantId) return;
  var originalText = btn.textContent;
  btn.textContent = 'Adding\u2026';
  btn.disabled = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({id: variantId, quantity: 1})
  })
  .then(function(r){ return r.json(); })
  .then(function(){
    refreshCart();
    openCart();
  })
  .catch(function(){ showToast('Could not add to cart. Please try again.'); })
  .finally(function(){ btn.textContent = originalText; btn.disabled = false; });
}

function formatMoney(cents){
  return '\u20ac' + (cents / 100).toFixed(2);
}

// ── CART DRAWER ──────────────────────────────────────────
function openCart(){
  refreshCart();
  document.getElementById('cartOverlay').classList.add('open');
  document.getElementById('cartDrawer').classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeCart(){
  document.getElementById('cartOverlay').classList.remove('open');
  document.getElementById('cartDrawer').classList.remove('open');
  document.body.style.overflow = '';
}

function refreshCart(){
  fetch('/cart.js')
    .then(function(r){ return r.json(); })
    .then(renderCart)
    .catch(function(){});
}

function renderCart(cart){
  var itemsEl = document.getElementById('cartItems');
  var footerEl = document.getElementById('cartFooter');
  var subtotalEl = document.getElementById('cartSubtotal');
  var countEls = [document.getElementById('cartCount'), document.getElementById('cartCountMobile')];

  var totalQty = cart.item_count || 0;
  countEls.forEach(function(el){
    if(!el) return;
    if(totalQty > 0){
      el.textContent = totalQty;
      el.style.display = 'flex';
    } else {
      el.style.display = 'none';
    }
  });

  if(!cart.items || cart.items.length === 0){
    itemsEl.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
    footerEl.style.display = 'none';
    return;
  }

  itemsEl.innerHTML = '';
  cart.items.forEach(function(item){
    var row = document.createElement('div');
    row.className = 'cart-item';

    var imgHtml = item.image
      ? '<img src="' + item.image + '" alt="' + (item.product_title || '') + '">'
      : '';

    var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<p class="cart-item-variant">' + item.variant_title + '</p>'
      : '';

    row.innerHTML =
      '<div class="cart-item-img">' + imgHtml + '</div>' +
      '<div class="cart-item-info">' +
        '<p class="cart-item-title">' + item.product_title + '</p>' +
        variantHtml +
        '<div class="cart-item-row">' +
          '<div class="cart-item-qty">' +
            '<button class="cart-qty-btn" data-action="decrease" data-key="' + item.key + '" data-qty="' + item.quantity + '">&minus;</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button class="cart-qty-btn" data-action="increase" data-key="' + item.key + '" data-qty="' + item.quantity + '">+</button>' +
          '</div>' +
          '<span class="cart-item-price">' + formatMoney(item.final_line_price) + '</span>' +
        '</div>' +
        '<button class="cart-item-remove" data-key="' + item.key + '">Remove</button>' +
      '</div>';

    itemsEl.appendChild(row);
  });

  footerEl.style.display = 'block';
  subtotalEl.textContent = formatMoney(cart.total_price);
}

function updateCartItem(key, quantity){
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({id: key, quantity: quantity})
  })
  .then(function(r){ return r.json(); })
  .then(renderCart)
  .catch(function(){ showToast('Could not update cart. Please try again.'); });
}

// ── KLAVIYO EMAIL CAPTURE ─────────────────────────────────
// Single reusable function for all four capture points.
// email       - the address to subscribe
// source      - where the signup came from (e.g. 'flight-001-landing-a')
// productName - product title, passed through to Klaviyo profile property
// formEl      - the form wrapper to hide on success
// successEl   - the success message element to show
// btnEl       - optional button element for loading state
function klaviyoSubscribe(email, source, productName, formEl, successEl, btnEl){
  if(!email || email.indexOf('@') === -1){ return false; }

  if(btnEl){ btnEl.textContent = 'Joining\u2026'; btnEl.disabled = true; }

  var properties = { signup_source: source };
  if(productName){ properties.signup_product = productName; }

  var payload = {
    data: {
      type: 'subscription',
      attributes: {
        profile: {
          data: {
            type: 'profile',
            attributes: {
              email: email,
              properties: properties
            }
          }
        }
      },
      relationships: {
        list: {
          data: {
            type: 'list',
            id: 'SBWmfx'
          }
        }
      }
    }
  };

  fetch('https://a.klaviyo.com/client/subscriptions/?company_id=UFcZTY', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'revision': '2023-12-15'
    },
    body: JSON.stringify(payload)
  })
  .then(function(r){
    if(r.ok || r.status === 202){
      if(formEl) formEl.style.display = 'none';
      if(successEl) successEl.style.display = 'block';
    } else {
      throw new Error('Klaviyo error ' + r.status);
    }
  })
  .catch(function(){
    if(btnEl){ btnEl.textContent = 'Try again'; btnEl.disabled = false; }
  });

  return true;
}

// ── SHOP SECTION — DROP CARD SUBMIT ──────────────────────
// Called inline from shop.liquid. source and productName come from Liquid.
function dropSubmit(productId, source, productName){
  var emailEl = document.getElementById('dropEmail_' + productId);
  var formEl  = document.getElementById('dropForm_' + productId);
  var succEl  = document.getElementById('dropSuccess_' + productId);
  var email   = emailEl ? emailEl.value.trim() : '';
  if(!email){ if(emailEl) emailEl.focus(); return; }
  klaviyoSubscribe(email, source, productName, formEl, succEl, null);
}

// ── FLIGHT 001 LANDING — SUBMIT ───────────────────────────
// source and productName are written into data attributes on the form
// elements by flight-001.liquid, then read here at submit time.
function flSubmit(){
  var email  = document.getElementById('flEmail').value.trim();
  var formEl = document.getElementById('flForm');
  var succEl = document.getElementById('flSuccess');
  var btnEl  = document.getElementById('flBtn');
  var source  = formEl ? (formEl.dataset.source  || 'flight-001-landing') : 'flight-001-landing';
  var product = formEl ? (formEl.dataset.product || '') : '';
  if(!klaviyoSubscribe(email, source, product, formEl, succEl, btnEl)){
    document.getElementById('flEmail').focus();
  }
}

function flSubmit2(){
  var email  = document.getElementById('flEmail2').value.trim();
  var formEl = document.getElementById('flForm2');
  var succEl = document.getElementById('flSuccess2');
  var source  = formEl ? (formEl.dataset.source  || 'flight-001-landing') : 'flight-001-landing';
  var product = formEl ? (formEl.dataset.product || '') : '';
  if(!klaviyoSubscribe(email, source, product, formEl, succEl, null)){
    document.getElementById('flEmail2').focus();
  }
}

// ── INIT ─────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function(){

  // Add to Cart
  var addBtn = document.getElementById('modal-add');
  if(addBtn){
    addBtn.addEventListener('click', function(){
      var activeSize = document.querySelector('#modal-sizes .size-btn.active');
      if(!activeSize) return;
      var variantId = parseInt(activeSize.dataset.variantId);
      this.textContent = 'Adding\u2026';
      this.disabled = true;
      var self = this;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: variantId, quantity: 1})
      })
      .then(function(r){ return r.json(); })
      .then(function(){
        closeModal();
        showToast('Added to cart \u2713');
        refreshCart();
        openCart();
      })
      .catch(function(){ showToast('Could not add to cart. Please try again.'); })
      .finally(function(){ self.textContent = 'Add to Cart'; self.disabled = false; });
    });
  }

  // Escape key
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){ closeModal(); closeCart(); }
  });

  // Cart item quantity / remove (event delegation)
  var cartItemsEl = document.getElementById('cartItems');
  if(cartItemsEl){
    cartItemsEl.addEventListener('click', function(e){
      var qtyBtn = e.target.closest('.cart-qty-btn');
      var removeBtn = e.target.closest('.cart-item-remove');
      if(qtyBtn){
        var key = qtyBtn.dataset.key;
        var qty = parseInt(qtyBtn.dataset.qty);
        var next = qtyBtn.dataset.action === 'increase' ? qty + 1 : qty - 1;
        updateCartItem(key, Math.max(0, next));
      } else if(removeBtn){
        updateCartItem(removeBtn.dataset.key, 0);
      }
    });
  }

  // Load initial cart count
  refreshCart();

  // Flight 001 — enter key on inputs
  var flEmail = document.getElementById('flEmail');
  if(flEmail){ flEmail.addEventListener('keydown', function(e){ if(e.key === 'Enter') flSubmit(); }); }
  var flEmail2 = document.getElementById('flEmail2');
  if(flEmail2){ flEmail2.addEventListener('keydown', function(e){ if(e.key === 'Enter') flSubmit2(); }); }

  // Flight 001 — countdown
  (function(){
    var cd = document.querySelector('.fl-countdown');
    if(!cd) return;
    var target = new Date(cd.dataset.launch).getTime();
    function tick(){
      var diff = target - Date.now();
      if(isNaN(target) || diff <= 0){ cd.style.display = 'none'; return; }
      cd.querySelector('[data-days]').textContent = String(Math.floor(diff/86400000)).padStart(2,'0');
      cd.querySelector('[data-hours]').textContent = String(Math.floor(diff%86400000/3600000)).padStart(2,'0');
      cd.querySelector('[data-mins]').textContent = String(Math.floor(diff%3600000/60000)).padStart(2,'0');
    }
    tick();
    setInterval(tick, 60000);
  })();

  // Scroll reveal
  var obs = new IntersectionObserver(
    function(entries){ entries.forEach(function(e){ if(e.isIntersecting) e.target.classList.add('visible'); }); },
    {threshold: 0.08}
  );
  document.querySelectorAll('.reveal').forEach(function(el){ obs.observe(el); });

  // Carousel touch
  var co = document.querySelector('.carousel-overflow');
  if(co){
    var tx = 0;
    co.addEventListener('touchstart', function(e){ tx = e.touches[0].clientX; }, {passive: true});
    co.addEventListener('touchend', function(e){
      var dx = tx - e.changedTouches[0].clientX;
      if(Math.abs(dx) > 40) slide(dx > 0 ? 1 : -1);
    }, {passive: true});
  }
});

/* ─── V16.1: PRODUCT PAGE (PDP) ─────────────────────── */
function pdpSelectVariant(btn){
  document.querySelectorAll('#pdpSizes .size-btn').forEach(function(b){ b.classList.remove('active'); });
  btn.classList.add('active');
  var add = document.getElementById('pdpAdd');
  if(add){ add.dataset.productId = btn.dataset.variantId; }
  var price = document.getElementById('pdpPrice');
  if(price && btn.dataset.price){ price.textContent = formatMoney(parseInt(btn.dataset.price, 10)); }
}

/* ─── V16.4: PRODUCT PAGE ────────────────────────────── */
function pdpSelectVariant(btn){
  document.querySelectorAll('#pdpSizes .size-btn').forEach(function(b){ b.classList.remove('active'); });
  btn.classList.add('active');
  var add = document.getElementById('pdpAdd');
  if(add){ add.dataset.productId = btn.dataset.variantId; }
  var price = document.getElementById('pdpPrice');
  if(price && btn.dataset.price){ price.textContent = formatMoney(parseInt(btn.dataset.price, 10)); }
}

/* ─── V16.6: NAV DRAWER ──────────────────────────────── */
function toggleNavDrawer() {
  var drawer = document.getElementById('navDrawer');
  var overlay = document.getElementById('navDrawerOverlay');
  var hamburger = document.getElementById('hamburger');
  var isOpen = drawer.classList.contains('is-open');
  if (isOpen) {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    hamburger.classList.remove('is-open');
    hamburger.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  } else {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    hamburger.classList.add('is-open');
    hamburger.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
}
// Close on ESC
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    var drawer = document.getElementById('navDrawer');
    if (drawer && drawer.classList.contains('is-open')) toggleNavDrawer();
  }
});
